var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeatOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7870_456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7870_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3236 20.4966L11.4005 21.5736C11.5244 21.6975 11.5856 21.8425 11.584 22.0086C11.5824 22.1748 11.5212 22.3225 11.4005 22.4518C11.2712 22.5811 11.1227 22.6479 10.9551 22.6522C10.7873 22.6564 10.6388 22.5939 10.5095 22.4647L8.44384 20.3989C8.36578 20.3209 8.31078 20.2387 8.27884 20.1522C8.24675 20.0657 8.23071 19.9722 8.23071 19.8718C8.23071 19.7712 8.24675 19.6777 8.27884 19.5911C8.31078 19.5046 8.36578 19.4224 8.44384 19.3445L10.5095 17.2786C10.6335 17.1548 10.7806 17.0936 10.9509 17.0953C11.1213 17.0968 11.2712 17.1623 11.4005 17.2916C11.5212 17.4209 11.5837 17.5673 11.588 17.7307C11.5923 17.8942 11.5298 18.0405 11.4005 18.1697L10.3236 19.2468H19.0384C19.1131 19.2468 19.1745 19.2227 19.2226 19.1745C19.2706 19.1264 19.2947 19.065 19.2947 18.9903V16.5384C19.2947 16.3611 19.3545 16.2125 19.4743 16.0928C19.5938 15.9732 19.7423 15.9134 19.9197 15.9134C20.097 15.9134 20.2456 15.9732 20.3653 16.0928C20.4849 16.2125 20.5447 16.3611 20.5447 16.5384V18.9903C20.5447 19.4059 20.3975 19.7608 20.1032 20.0551C19.8089 20.3494 19.454 20.4966 19.0384 20.4966H10.3236ZM19.6761 10.753H10.9613C10.8866 10.753 10.8252 10.7771 10.7772 10.8253C10.7291 10.8734 10.7051 10.9348 10.7051 11.0095V13.4614C10.7051 13.6387 10.6452 13.7873 10.5255 13.907C10.4059 14.0266 10.2574 14.0864 10.0801 14.0864C9.90273 14.0864 9.75419 14.0266 9.63446 13.907C9.51488 13.7873 9.45509 13.6387 9.45509 13.4614V11.0095C9.45509 10.5939 9.60224 10.239 9.89655 9.94469C10.1909 9.65038 10.5458 9.50323 10.9613 9.50323H19.6761L18.5993 8.42615C18.4754 8.30226 18.4142 8.15726 18.4157 7.99115C18.4174 7.82504 18.4786 7.67733 18.5993 7.54802C18.7286 7.41872 18.877 7.35191 19.0447 7.34761C19.2125 7.34344 19.361 7.40594 19.4903 7.53511L21.5559 9.60094C21.634 9.67886 21.689 9.76108 21.7209 9.84761C21.753 9.93414 21.769 10.0276 21.769 10.128C21.769 10.2286 21.753 10.3221 21.7209 10.4086C21.689 10.4952 21.634 10.5774 21.5559 10.6553L19.4903 12.7211C19.3663 12.845 19.2191 12.9061 19.0488 12.9045C18.8784 12.903 18.7286 12.8375 18.5993 12.7082C18.4786 12.5789 18.4161 12.4325 18.4118 12.2691C18.4075 12.1056 18.47 11.9593 18.5993 11.8301L19.6761 10.753Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatOff);
export default __webpack_public_path__ + "static/media/repeatOFF.e532998970c22cdeb2d4b5be87f0a76e.svg";
export { ForwardRef as ReactComponent };